/**
 * Flutterwave Supported Countries
 * 
 * Maps country codes to country names for the 14 African countries
 * supported by Flutterwave payment rails.
 */

export interface Country {
  code: string;
  name: string;
}

/**
 * List of countries supported by Flutterwave
 * Ordered alphabetically by name for better UX in dropdown.
 *
 * NOTE: This list is for the *country selector dropdown* in PaymentMethodModal.
 * It does NOT dictate which payment methods are enabled per country —
 * that is controlled by COUNTRY_PAYMENT_CONFIG in payment_config.ts.
 */
export const SUPPORTED_COUNTRIES: Country[] = [
  { code: "BF", name: "Burkina Faso" },
  { code: "CM", name: "Cameroon" },
  { code: "CI", name: "Côte d'Ivoire" },
  { code: "EG", name: "Egypt" },
  { code: "GH", name: "Ghana" },
  { code: "KE", name: "Kenya" },
  { code: "NG", name: "Nigeria" },
  { code: "RW", name: "Rwanda" },
  { code: "SN", name: "Senegal" },
  { code: "ZA", name: "South Africa" },
  { code: "TZ", name: "Tanzania" },
  { code: "UG", name: "Uganda" },
  { code: "ZM", name: "Zambia" },
];

/**
 * Get country name from country code
 */
export function getCountryName(code: string): string | null {
  const country = SUPPORTED_COUNTRIES.find(c => c.code === code.toUpperCase());
  return country?.name || null;
}

/**
 * Get country code from country name
 */
export function getCountryCode(name: string): string | null {
  const country = SUPPORTED_COUNTRIES.find(
    c => c.name.toLowerCase() === name.toLowerCase()
  );
  return country?.code || null;
}
